module.exports = __webpack_public_path__ + "static/img/liquid-biofuel_256.f56e4be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liquid-biofuel_256.png
// module id = zs0I
// module chunks = 0